import styled from "styled-components";
import {DARK_GRAY_COLOR, GRAY_COLOR, INPUT_BORDER_COLOR} from "../../constants/colors";

export const SelectChat = styled.div`
  width: 100%;
  height: 100%;
`;

export const SelfAvatarContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
`;

export const SelfAvatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ModalDivider = styled.div`
  border-bottom: 1px solid var(--border-color);
  padding: .8rem 1rem;
`;

export const ModalTitle = styled.h5`
  font-size: 1rem;
`;

export const SearchInput = styled.input`
  border: 1px solid ${INPUT_BORDER_COLOR};
  border-right: none;
  border-radius: 6px 0 0 6px;
  width: 100%;
  padding: .7rem .5rem;
  color: ${DARK_GRAY_COLOR};
  
  &::placeholder {
    font-size: .8rem;
  }
  
  &.lng-rtl {
    &::placeholder {
      text-align: right;
    }  
  }
  
  &:focus {
    outline: none;
  }
`;

export const SearchIconBox = styled.button`
  width: 50px;
  background-color: ${GRAY_COLOR};
  border: 1px solid ${INPUT_BORDER_COLOR};
  border-left: none;
  border-radius: 0 6px 6px 0;
`;

export const SearchIcon = styled.i`
  color: ${DARK_GRAY_COLOR};
`;

export const ChatContactAvatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
`;

export const ChatContactImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ChatContactName = styled.p`
  margin-left: .5rem;
  font-size: .8rem;
  margin-bottom: 0;
`;

export const HeaderActionIcon = styled.i`
  color: var(--main-text-color);
  transition: .2s;

  &:hover {
    opacity: .8;
  }
`;
